import { all, call, spawn, takeLatest } from 'redux-saga/effects';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';
import { logCvDownload, logCvPrint, logJobStatisticsView } from './graphql';

function* logCvPrintGenerator(action: ReduxAction): any {
  try {
    yield call(logCvPrint, action.payload);
  } catch (e: any) {
    log(e);
  }
}

function* logCvDownloadGenerator(action: ReduxAction): any {
  try {
    yield call(logCvDownload, action.payload);
  } catch (e: any) {
    log(e);
  }
}

function* logJobStatisticsViewGenerator(action: ReduxAction): any {
  try {
    yield call(logJobStatisticsView, action.payload);
  } catch (e: any) {
    log(e);
  }
}

function* cvPrint() {
  yield takeLatest(actions.LOG_CV_PRINT, logCvPrintGenerator);
}

function* cvDownload() {
  yield takeLatest(actions.LOG_CV_DOWNLOAD, logCvDownloadGenerator);
}

function* jobStatisticsView() {
  yield takeLatest(actions.LOG_JOB_STATISTICS_VIEW, logJobStatisticsViewGenerator);
}

export default function* rootSaga() {
  yield all([spawn(cvPrint), spawn(cvDownload), spawn(jobStatisticsView)]);
}
